// extracted by mini-css-extract-plugin
module.exports = {"playerControls":"_1ONPI4","packshot":"_2M3Tww"};